var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoIcon = function SvgLogoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logoIcon_svg__a)",
    d: "M12.82 11.704c-.17.072-.746.328-.9.416-2.225 1.232-7.703 7.712-7.711 8.768v.072c.105.56 9.31 1.232 11.801.456.17-.056.755-.296.926-.368a5.12 5.12 0 0 0 3.117-4.688c0-.68-.138-1.368-.43-2.032-.853-1.912-2.76-3.056-4.749-3.056-.69 0-1.388.136-2.062.424"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logoIcon_svg__b)",
    d: "M5.07 3.888a6 6 0 0 0-1.283 1.96c-.08.2-.365.912-.422 1.12C3.114 7.84 3 9.352 3 11.072c0 3.768.511 8.536 1.096 9.72.065.128.122.2.186.24 1.161.904 8.937-6.816 10.617-9.456.22-.344.406-.736.569-1.256q.33-1.082.332-2.152c0-2.488-1.363-4.736-3.863-5.736A6.4 6.4 0 0 0 9.932 2h-.325a6.36 6.36 0 0 0-4.53 1.896"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logoIcon_svg__a",
    x1: 20,
    x2: 9,
    y1: 18,
    y2: 18.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF9F73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#967651"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logoIcon_svg__b",
    x1: 9.4,
    x2: 9.4,
    y1: 2,
    y2: 21.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4AD8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9915C"
  })))));
};
export default SvgLogoIcon;